import { render, staticRenderFns } from "./DevClassModal.vue?vue&type=template&id=6c7aceb6&"
import script from "./DevClassModal.vue?vue&type=script&lang=js&"
export * from "./DevClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports